import {Logger as WebBiLogger} from '@wix/web-bi-logger/dist/src/types';
import {AppReflowRuleType} from '@wix/wixstores-client-core/dist/es/src/constants';
import {sfProductPageVariantSetupCompletedSrc10Evid699} from '@wix/bi-logger-stores-data/v2';
import {BiStoresReflowPageName, RuleDef} from './types';

const RULE_TYPE_TO_BI_STRING_MAP: Record<AppReflowRuleType, string> = {
  [AppReflowRuleType.Products]: 'products',
  [AppReflowRuleType.Categories]: 'categories',
  [AppReflowRuleType.NestedCategories]: 'nested-categories',
};

export const sendBi = ({
  biStoresReflowPageName,
  webBiLogger,
  isEdit,
  pageVariantId,
  originalPageId,
  duplicatedPageId,
  pageVariantType,
  ruleDef,
  flowId,
  msid,
}: {
  biStoresReflowPageName: BiStoresReflowPageName;
  webBiLogger: WebBiLogger;
  isEdit: boolean;
  pageVariantId: string;
  originalPageId: string;
  duplicatedPageId: string;
  pageVariantType: string;
  ruleDef: RuleDef;
  flowId: string;
  msid: string;
}) => {
  let ruleType = null;
  if (ruleDef?.values?.length && ruleDef?.type) {
    ruleType = RULE_TYPE_TO_BI_STRING_MAP[ruleDef.type];
  }

  return webBiLogger.report(
    sfProductPageVariantSetupCompletedSrc10Evid699({
      origin: isEdit ? 'edit page rule' : 'create page rule',
      storesPageName: biStoresReflowPageName,
      pageVariantId,
      originalPageId,
      duplicatedPageId,
      pageVariantType,
      // eslint-disable-next-line no-nested-ternary
      ruleType,
      ruleValues: ruleDef?.values?.length ? JSON.stringify(ruleDef.values) : null,
      flowId,
      msid,
    })
  );
};
